<!-- Important! it fix problems with checked options from multiselect.vue-->
<template>
  <div :class="formGroupClass">
    <label :class="labelClass">{{ title }}</label>
    <div :class="inputClass">
      <vue-multiselect
          v-model="valueHolder"
          :options="options"
          :searchable="true"
          :multiple="true"
          :label="label"
          :track-by="trackBy"
          placeholder=""
          :select-label="labelSelect"
          :deselect-label="labelDeselect"
          :selected-label="labelSelected"
          @select="$emit('dispatch', $event)"
          @input="passTrackBy"
      >
        <span slot="noResult">Brak wyników. Spróbuj zmienić wpisywaną frazę.</span>
      </vue-multiselect>
      <span v-if="errorText" class="help-block">
        <p> {{errorText}} </p>
      </span>
    </div>
  </div>
</template>

<script>
import VueMultiselect from 'vue-multiselect'

export default {
  components: {
    VueMultiselect
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: 'name',
    },
    trackBy: {
      type: String,
      default: 'id',
    },
    value: {
      type: Array,
      default: null,
    },
    title: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    errors: {
      type: Object,
      default: () => {},
    },
    labelSize: {
      type: Number,
      default: 3,
    },
  },
  data: function () {
    return {
      valueHolder: null,
      id: `form_${this.name}`,
      errorText: false,
      selectValues: [],
      checkValues: [],
      labelSelect: Translator.trans('multiselect.select'),
      labelDeselect: Translator.trans('multiselect.remove'),
      labelSelected: Translator.trans('multiselect.selected'),
      formGroupClass: 'form-group',
      labelClass: `control-label col-md-${this.labelSize}`,
      inputClass: `col-md-${12 - this.labelSize}`,
      forceChange: 0
    }
  },
  watch: {
    options: function () {
      this.findValueInOptions()
    },
    value: function () {
      this.findValueInOptions()
    }
  },
  mounted () {
    this.findValueInOptions()

    if (typeof this.value === 'undefined') {
      this.$emit('input', [])
    }
  },
  methods: {
    passTrackBy (checked) {
      this.valueHolder = checked
      if (!this.options.length) {
        return
      }
      if (checked && checked.constructor === Array) {
        let value = []
        checked.forEach((el) => {
          if (el[this.trackBy]) {
            value.push(el[this.trackBy])
          }
        })
        this.$emit('input', value)
      } else {
        this.$emit('input', null)
      }
    },
    findValueInOptions () {
      let checked = []

      if (typeof this.value !== 'undefined')
        if (this.options.length && this.value !== null && this.value.length) {
          let BreakException = {}

          try {
            this.options.forEach((el) => {
              this.value.forEach((check) => {
                if (el[this.trackBy] && el[this.trackBy] === check) {
                  checked.push(el)
                  if (this.value.length === checked.length) {
                    throw BreakException
                  }
                }
              })
            })
          } catch (e) {
            if (e !== BreakException) throw e
          }
        }

      this.valueHolder = checked

    }
  }

}
</script>
